import { onCleanup, onMount, type ParentComponent } from 'solid-js';
import { useQueryClient } from '@tanstack/solid-query';
import { onRealtimeConnected, realtimeHub } from '../api/signalr';
import { applyBookingRescheduled } from './cache-mutations';
import { INVALIDATION_MAP } from './invalidation-map';

export const RealtimeSyncProvider: ParentComponent = (props) => {
  const queryClient = useQueryClient();

  onMount(() => {
    const offFns: Array<() => void> = [];
    // Пачка событий одного серверного прохода приходит отдельными кадрами: ключи копятся в окне от
    // первого события, и каждый сбрасывается один раз. Окно не продлевается, иначе поток отодвигал бы сброс.
    const pending = new Map<string, readonly unknown[]>();
    let flushTimer: ReturnType<typeof setTimeout> | undefined;
    const flush = (): void => {
      flushTimer = undefined;
      for (const queryKey of pending.values()) queryClient.invalidateQueries({ queryKey });
      pending.clear();
    };

    for (const [topic, keys] of Object.entries(INVALIDATION_MAP)) {
      if (!keys) continue;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const off = (realtimeHub.on as any)(topic, () => {
        for (const queryKey of keys)
          pending.set(JSON.stringify(queryKey), queryKey as readonly unknown[]);
        flushTimer ??= setTimeout(flush, 100);
      });
      offFns.push(off);
    }

    offFns.push(
      realtimeHub.on('BookingRescheduled', (payload) =>
        applyBookingRescheduled(queryClient, {
          bookingId: payload.bookingId,
          toCourtId: payload.toCourtId,
          startAt: payload.startAt,
          endAt: payload.endAt,
        }),
      ),
    );

    // Сокет не доставляет пропущенное за обрыв: догоняет только перечитывание экрана.
    offFns.push(
      onRealtimeConnected(() => {
        void queryClient.invalidateQueries({ refetchType: 'active' });
      }),
    );

    onCleanup(() => {
      for (const off of offFns) off();
      clearTimeout(flushTimer);
    });
  });

  return <>{props.children}</>;
};
